import React, { ReactChild } from 'react'
import { useTranslation } from 'react-i18next'
import { AlertType } from '../../../../../types/campaign'
import TooltipHelp from '../../../../../components/TooltipHelp'
import IconAlert from '../../../../../components/Icon/IconAlert'

const CreationsPercentageTooltipAlert: React.FC = () => {
  const { t } = useTranslation()

  const tooltip = (alertType: AlertType, message: string): ReactChild => {
    return (
      <TooltipHelp
        containerClassName={`CreationsFormEmissionNumber__emissions--tooltip-${alertType.toString()}`}
      >
        <div className={'CreationsFormEmissionNumber__emissions--alert'}>
          <div className='Alerts__alert'>
            <div className={'CreationsFormEmissionNumber__emissions--alert'}>
              {(alertType === AlertType.warning || alertType === AlertType.alert) && (
                <div className={'Alerts__header'}>
                  <IconAlert alertType={alertType} />
                </div>
              )}
              <div className='Alerts__alert'>{message}</div>
            </div>
          </div>
        </div>
      </TooltipHelp>
    )
  }
  const getTooltipAlert = (): ReactChild => {
    return tooltip(
      AlertType.info,
      t('form.campaign.creations.creationsPercentageShareCannotBeHigherThan100')
    )
  }

  return <>{getTooltipAlert()}</>
}

export default CreationsPercentageTooltipAlert
